import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapSingle } from '../ruutsApi/normalize'

const ACTIVITIES = [
  { name: 'G', fullName: 'General' },
  { name: 'L', fullName: 'Loteo' },
  { name: 'Pa', fullName: 'Pastoreo' },
  { name: 'FO', fullName: 'Fertilizantes orgánicos' },
  { name: 'FS', fullName: 'Fertilizantes sintéticos' },
  { name: 'La', fullName: 'Labranza' },
  { name: 'Ag', fullName: 'Agua' },
  { name: 'Co', fullName: 'Combustible' },
  { name: 'Cu', fullName: 'Cultivos' },
]

// Rebuilt per call: a shared module-level instance would let one caller's mutation of the
// serialized body leak into the next request.
const buildEmptyActivitiesStatus = () =>
  ACTIVITIES.map(activity => ({ ...activity, status: 'empty', selectedPaddocksIds: [] }))

export const createFarmSubdivision = async ({ farmSubdivision }) => {
  const response = await apiClient.post(endpoints.farmSubdivisions, farmSubdivision)
  return unwrapSingle(response)
}

// The KML flow creates a loteo with no predecessor to inherit from, so it seeds the empty
// per-activity data-collection scaffold itself.
export const saveFarmSubdivision = async ({ farm, data }) =>
  createFarmSubdivision({
    farmSubdivision: {
      paddockIds: data.paddockIds,
      activitiesStatus: buildEmptyActivitiesStatus(),
      year: data.year,
      farmId: farm.id,
    },
  })
